<template>
  <q-btn @click="exportXlsx" color="primary" label="Export"></q-btn>
</template>

<script>
import axios from "../axios/";
export default {
  props: {
    company_id: String,
    location_id: Array,
    statuses: Array,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async nameGenerator() {
      let name = `export-tree-view-by-make-and-model-`;
      var currentdate = new Date();
      var datetime =
        currentdate.getDate() +
        "_" +
        (currentdate.getMonth() + 1) +
        "_" +
        currentdate.getFullYear() +
        "_" +
        currentdate.getHours() +
        ":" +
        currentdate.getMinutes() +
        ":" +
        currentdate.getSeconds();
      name += datetime;
      return name;
    },
    paramCreator() {
      const params = {};
      if (this.location_id) {
        params.location_id = this.location_id.map((item) => item.id);
      }
      if (this.company_id) {
        params.company_id = this.company_id;
      }
      if (this.statuses) {
        params.statuses = this.statuses.map(status => status.value);
      }
      return { params };
    },
    async exportXlsx() {
      this.loading = true;
      const params = this.paramCreator();
      const {
        data,
      } = await axios.post(
        `vehicle-analysis/export-tree-view-by-make-and-model`,
        {},
        {
          responseType: 'blob',
          ...params,
        }
      );
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      const name = await this.nameGenerator();
      link.setAttribute("download", `${name}.xlsx`);
      document.body.appendChild(link);
      link.click();
      this.loading = false;
      this.exportEx = false;
    },
  },
};
</script>
